import * as PIXI from 'pixi.js';
import {pixiComponents} from "../index";
import {spinStore, store} from "../store";
import {cpConfigs} from "../controlPanel/configs";
import {updateBalanceInfoText, updateBetAmountInfoText} from "../controlPanel";
import {balanceTextInfo, betTextInfo, freeSpinsLeftTextInfo, winTextInfo} from "../controlPanel/amountText";
import {betSettingsSectionUi} from "../controlPanel/betSettingsSection";
import {isHorizontalScreen} from "../utilites";
import {buyFreeSpinsBoardConfigs, getBonusWinAmountBoardPosition} from "../freeSpin";
import {updateQuestionItemsPositions} from "../freeSpin/questionModalBuyFreeSpins";
import {Texture} from "pixi.js";
import {uiConfig} from "../controlPanel/autoSpin";

export const updateCanvasByMobileOrientation = () => isHorizontalScreen() ?
    setPixiAppMobileHorizontal() :
    setPixiAppMobileVertical();

export const setPixiAppMobileVertical = () => {
    pixiComponents.app.renderer.resize(560, 960);
    updatePixiBackground();
    setControlPanelVertical();
    setBuyFreeSpinBoardVertical();
    updateQuestionItemsPositions();
    setLogoForVertical();
    pixiComponents.slotBoard.updateContainerPosition();
    pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.updatePositionAndScale();
}

export const setPixiAppMobileHorizontal = () => {
    pixiComponents.app.renderer.resize(960, 560);
    updatePixiBackground();
    setControlPanelHorizontal();
    setBuyFreeSpinBoardHorizontal();
    updateQuestionItemsPositions();
    setLogoForHorizontal();
    pixiComponents.slotBoard.updateContainerPosition();
    pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.updatePositionAndScale();
}

const updatePixiBackground = () => {
    const {background, bonusBackground} = pixiComponents;
    background.width = pixiComponents.app.screen.width;
    background.height = pixiComponents.app.screen.height;
    background.x = pixiComponents.app.screen.width / 2;
    background.y = pixiComponents.app.screen.height / 2;

    bonusBackground.width = pixiComponents.app.screen.width;
    bonusBackground.height = pixiComponents.app.screen.height;
    bonusBackground.x = pixiComponents.app.screen.width / 2;
    bonusBackground.y = pixiComponents.app.screen.height / 2;

    if (store.isHorizontalScreen) {
        background.texture = PIXI.Texture.from("./assets/bg.webp");
        bonusBackground.texture = PIXI.Texture.from("./assets/bonusBg.webp");
    } else {
        background.texture = PIXI.Texture.from("./assets/mobile-bg.webp");
        bonusBackground.texture = PIXI.Texture.from("./assets/bonusMobileBg.webp");
    }
}


const setControlPanelVertical = () => {
    const {controlPanelContainer, cpItems, sessionExpiredComponent} = pixiComponents;
    const {
        historyBtn,
        infoBtn,
        soundSwitcher,
        balanceAmountText,
        betAmountText,
        winAmountText,
        spinBtn,
        freeSpinLeftText,
        stopAutoSpinBtn,
        stopSpinBtn,
        autoSpinBtn,
        amountBtn,
        betSettingsSection,
        autoBetSelector,
        freeSinsLeftText,
    } = cpItems;
    controlPanelContainer.y = cpConfigs.y;

    winAmountText.container.y = winTextInfo.title.y;
    winAmountText.container.x = pixiComponents.app.screen.width / 2;

    freeSpinLeftText.container.y = winTextInfo.title.y;
    freeSpinLeftText.container.x = pixiComponents.app.screen.width / 2;

    balanceAmountText.title.x = balanceTextInfo.title.x;
    balanceAmountText.title.y = balanceTextInfo.title.y;
    balanceAmountText.title.style.fontSize = balanceTextInfo.fontSize;
    balanceAmountText.amount.style.fontSize = balanceTextInfo.fontSize;

    betAmountText.title.x = betTextInfo.title.x;
    betAmountText.title.y = betTextInfo.title.y;
    betAmountText.title.style.fontSize = balanceTextInfo.fontSize;
    betAmountText.amount.style.fontSize = balanceTextInfo.fontSize;

    soundSwitcher.x = cpConfigs.soundSwitcherBtn.x;
    historyBtn.x = cpConfigs.historyBtn.x;
    infoBtn.x = cpConfigs.infoBtn.x;

    updateBalanceInfoText(spinStore.userBalance);
    updateBetAmountInfoText(spinStore.spinAmount);

    spinBtn.x = cpConfigs.spinBtn.x;
    spinBtn.y = cpConfigs.spinBtn.y;

    stopAutoSpinBtn.x = cpConfigs.spinBtn.x;
    stopAutoSpinBtn.y = cpConfigs.spinBtn.y;

    stopSpinBtn.x = cpConfigs.spinBtn.x;
    stopSpinBtn.y = cpConfigs.spinBtn.y;

    autoSpinBtn.x = cpConfigs.autoSpinBtn.x;
    autoSpinBtn.y = cpConfigs.autoSpinBtn.y;

    amountBtn.x = cpConfigs.amountBtn.x;
    amountBtn.y = cpConfigs.amountBtn.y;

    betSettingsSection.pivot.set(betSettingsSectionUi.width / 2, betSettingsSectionUi.height / 2);
    betSettingsSection.x = pixiComponents.app.screen.width / 2;
    betSettingsSection.y = -betSettingsSectionUi.height;

    autoBetSelector.x = autoSpinBtn.x - uiConfig.width / 2;
    autoBetSelector.y = autoSpinBtn.y - cpConfigs.autoSpinBtn.height / 2 + 17;

    if (sessionExpiredComponent) {
        sessionExpiredComponent.children[1].x = pixiComponents.app.screen.width / 2;
        sessionExpiredComponent.children[1].y = pixiComponents.app.screen.height / 2;
    }

    freeSinsLeftText.style.fontSize = freeSpinsLeftTextInfo.fontSize;
    freeSinsLeftText.x = pixiComponents.app.screen.width / 2;
    freeSinsLeftText.y = freeSpinsLeftTextInfo.y;
}

const setControlPanelHorizontal = () => {
    const {controlPanelContainer, cpItems, sessionExpiredComponent} = pixiComponents;
    const {
        historyBtn,
        infoBtn,
        soundSwitcher,
        balanceAmountText,
        betAmountText,
        winAmountText,
        spinBtn,
        stopAutoSpinBtn,
        stopSpinBtn,
        autoSpinBtn,
        amountBtn,
        freeSpinLeftText,
        betSettingsSection,
        autoBetSelector,
        freeSinsLeftText,
    } = cpItems;

    controlPanelContainer.y = 240;
    winAmountText.container.y = 263;
    winAmountText.container.x = pixiComponents.app.screen.width / 2;

    freeSpinLeftText.container.y = 263;
    freeSpinLeftText.container.x = pixiComponents.app.screen.width / 2;

    balanceAmountText.title.x = 75;
    balanceAmountText.title.y = 250;
    balanceAmountText.title.style.fontSize = 34;
    balanceAmountText.amount.style.fontSize = 34;

    betAmountText.title.x = 75;
    betAmountText.title.y = 283;
    betAmountText.title.style.fontSize = 34;
    betAmountText.amount.style.fontSize = 34;

    soundSwitcher.x = 32;
    historyBtn.x = 32;
    infoBtn.x = 32;

    updateBalanceInfoText(spinStore.userBalance);
    updateBetAmountInfoText(spinStore.spinAmount);

    spinBtn.x = pixiComponents.app.screen.width - cpConfigs.spinBtn.width / 1.8;
    spinBtn.y = 220;

    stopAutoSpinBtn.x = pixiComponents.app.screen.width - cpConfigs.spinBtn.width / 1.8;
    stopAutoSpinBtn.y = 220;

    stopSpinBtn.x = pixiComponents.app.screen.width - cpConfigs.spinBtn.width / 1.8;
    stopSpinBtn.y = 220;

    autoSpinBtn.x = pixiComponents.app.screen.width - cpConfigs.autoSpinBtn.width / 1.8;
    autoSpinBtn.y = 105;

    amountBtn.x = 765;
    amountBtn.y = 270;

    betSettingsSection.pivot.set(betSettingsSectionUi.width / 2, betSettingsSectionUi.height / 2);
    betSettingsSection.x = pixiComponents.app.screen.width / 2;
    betSettingsSection.y = 0;

    autoBetSelector.x = autoSpinBtn.x - uiConfig.width / 2;
    autoBetSelector.y = autoSpinBtn.y - cpConfigs.autoSpinBtn.height / 2 + 15;

    if (sessionExpiredComponent) {
        sessionExpiredComponent.children[1].x = pixiComponents.app.screen.width / 2;
        sessionExpiredComponent.children[1].y = pixiComponents.app.screen.height / 2;
    }

    freeSinsLeftText.x = pixiComponents.app.screen.width / 2;
    freeSinsLeftText.style.fontSize = 32;
    freeSinsLeftText.y = 305;
}

const setBuyFreeSpinBoardVertical = () => {
    pixiComponents.buyFreeSpinsBoard.scale.x = 0.85;
    pixiComponents.buyFreeSpinsBoard.scale.y = 0.85;
    pixiComponents.buyFreeSpinsBoard.x = buyFreeSpinsBoardConfigs.x;
    pixiComponents.buyFreeSpinsBoard.y = buyFreeSpinsBoardConfigs.y;

    pixiComponents.winFreeSpinsText.x = pixiComponents.app.screen.width / 2;
    pixiComponents.winFreeSpinsText.y = pixiComponents.app.screen.height / 2.37;//2.4

    pixiComponents.bookAnimatedSprite.x = pixiComponents.app.screen.width / 1.97;
    pixiComponents.bookAnimatedSprite.y = pixiComponents.app.screen.height / 2.5;
    pixiComponents.bookAnimatedSprite.scale.set(0.57, 0.78);
}

const setBuyFreeSpinBoardHorizontal = () => {
    pixiComponents.buyFreeSpinsBoard.scale.x = 0.8;
    pixiComponents.buyFreeSpinsBoard.scale.y = 0.8;
    pixiComponents.buyFreeSpinsBoard.x = 25;
    pixiComponents.buyFreeSpinsBoard.y = 115;

    pixiComponents.winFreeSpinsText.x = pixiComponents.app.screen.width / 2;
    pixiComponents.winFreeSpinsText.y = pixiComponents.app.screen.height / 2;

    pixiComponents.bookAnimatedSprite.x = pixiComponents.app.screen.width / 2;
    pixiComponents.bookAnimatedSprite.y = pixiComponents.app.screen.height / 2.2;
    pixiComponents.bookAnimatedSprite.scale.set(0.85);
}

const setLogoForVertical = () => {
    pixiComponents.logo.visible = false;
    pixiComponents.logo2.visible = true;
}

const setLogoForHorizontal = () => {
    pixiComponents.logo.visible = true;
    pixiComponents.logo2.visible = false;

    const {logo} = pixiComponents;
    logo.anchor.set(0.5);
    logo.texture = Texture.from('./assets/logo1.webp');
    logo.position.x = 852;
    logo.position.y = 90;
    logo.rotation = Math.PI / 11;
    logo.width = 179;
    logo.height = 88;
}